import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { EditRestrictionReason } from 'modules/aftermarket';

interface Props {
  reason?: EditRestrictionReason;
  isSuperAdminOrSingleAccount: boolean;
}

export const EditRestrictionReasonMessage = ({ reason, isSuperAdminOrSingleAccount }: Props) => {
  const SuperAdminMessage = (
    <>
      You can only edit it because you are a{' '}
      <Box component="span" sx={{ fontWeight: 600 }}>
        Super Admin
      </Box>
      .
    </>
  );

  const editRestrictionReasons = {
    sharedProduct: (isSuperAdminOrSingleAccount: boolean) => (
      <Typography>
        This product has been shared with you. {isSuperAdminOrSingleAccount ? SuperAdminMessage : 'You cannot edit it.'}
      </Typography>
    ),
    licenseType: (isSuperAdminOrSingleAccount: boolean) => (
      <Typography>
        Your license type does not permit editing this product in Aftermarket Management.{' '}
        {isSuperAdminOrSingleAccount && SuperAdminMessage}
      </Typography>
    ),
    userRole: (isSuperAdminOrSingleAccount: boolean) => (
      <Typography>
        Your user role does not permit editing this product in Aftermarket Management.{' '}
        {isSuperAdminOrSingleAccount && SuperAdminMessage}
      </Typography>
    ),
  };

  if (!reason) {
    return null;
  }

  return editRestrictionReasons[reason] ? (
    <Alert variant="standard" color="warning" elevation={2}>
      {editRestrictionReasons[reason](isSuperAdminOrSingleAccount)}
    </Alert>
  ) : null;
};
